import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateHub from "../pages/Hub/CreateHub";
import EditHub from "../pages/Hub/EditHub";
import Hublist from "../pages/Hub/Hublist";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Hublist />} />
          <Route path="/create" element={<CreateHub />} />
          <Route path="/edit/:id" element={<EditHub />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
